export const NutrisenseLogo = () => {
  return <img src="/logo.svg" alt="Nutrisense Logo" style={{ width: '100%' }} />
}
